import React, { createContext, useContext, useMemo } from 'react';
/**
 * Context for alt-text fixer components
 * Provides all dependencies needed by the fixer component tree
 */
const AltTextFixerContext = /*#__PURE__*/createContext(null);

/**
 * Hook to access the alt-text fixer context
 * Must be used within an AltTextFixerProvider
 *
 * @throws Error if used outside of provider
 */
export const useAltTextFixerContext = () => {
  const context = useContext(AltTextFixerContext);
  if (!context) {
    throw new Error('useAltTextFixerContext must be used within an AltTextFixerProvider. ' + 'Make sure to wrap your alt-text fixer components with <AltTextFixerProvider>.');
  }
  return context;
};

/**
 * Props for the AltTextFixerProvider component
 */

/**
 * Provider component for alt-text fixer context.
 * See README.md for usage examples.
 */
export const AltTextFixerProvider = _ref => {
  let {
    value,
    children
  } = _ref;
  // Memoize the context value to prevent unnecessary re-renders
  const memoizedValue = useMemo(() => value, [value]);
  return /*#__PURE__*/React.createElement(AltTextFixerContext.Provider, {
    value: memoizedValue
  }, children);
};
//# sourceMappingURL=alt-text-fixer-context.js.map